import {TextInputField} from '../TextInputField';
import {TextArea} from '@/components/atoms';
import PropTypes from 'prop-types';
import {STRING_SCHEMA} from '@/services/schema/displayContentSchema';

export const DisplayContentFields = ({
  rows,
  fieldDefinitions,
  langCode,
  langData,
  fieldConfig,
  handleFieldChange,
  singleColumn = false
}) => (
  <>
    {rows.map((row) => (
      <div
        key={row.className}
        className={
          singleColumn
            ? row.className.replace('md:grid-cols-2', 'grid-cols-1')
            : row.className
        }
        data-testid={row.dataTestId}>
        {row.fields.map((fieldKey) => {
          const field = fieldDefinitions?.find(
            (definition) => definition.key === fieldKey
          );
          if (!field) return null;

          const commonProps = {
            value: langData?.[field.key] || '',
            label: fieldConfig[field.configKey].label,
            updateValue: (value, hasError) =>
              handleFieldChange(langCode, field.key, value, hasError),
            schema: STRING_SCHEMA,
            uiSchema: fieldConfig[field.configKey],
            required: field.required,
            visible: true
          };

          return field.type === 'textarea' ? (
            <TextArea key={field.key} {...commonProps} trim={false} />
          ) : (
            <TextInputField key={field.key} {...commonProps} />
          );
        })}
      </div>
    ))}
  </>
);

DisplayContentFields.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  fieldDefinitions: PropTypes.arrayOf(PropTypes.object).isRequired,
  langCode: PropTypes.string.isRequired,
  langData: PropTypes.object,
  fieldConfig: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  singleColumn: PropTypes.bool
};
